module.exports = __webpack_public_path__ + "images/6b4a7d6.png";